import styled from "styled-components";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import HowItWorks from "../components/HowItWorks";
import ProductGrid from "../components/ProductGrid";
import CTABanner from "../components/CTABanner";
import Reveal from "../components/Reveal";
import { Container, Section, Eyebrow } from "../components/ui";

export default function Home() {
  return (
    <>
      <Hero />

      <Section id="produktet">
        <Container>
          <Head>
            <Reveal>
              <Eyebrow>Tetë variante</Eyebrow>
              <H2>Një për çdo ditë që s'shkon si duhet</H2>
              <P>
                Çdo inhalator ka përzierjen e vet të vajrave esencialë organikë.
                Zgjedh atë që i përshtatet problemit që ke sot.
              </P>
            </Reveal>
          </Head>
          <ProductGrid />
        </Container>
      </Section>

      <Benefits />
      <HowItWorks />
      <CTABanner />
    </>
  );
}

const Head = styled.div`
  margin-bottom: 52px;
  max-width: 52ch;
`;

const H2 = styled.h2`
  font-size: ${({ theme }) => theme.size.h2};
  margin-bottom: 18px;
`;

const P = styled.p`
  color: ${({ theme }) => theme.colors.inkSoft};
  max-width: 48ch;
`;
